import { apiClient } from '@app/api';
import { useAuth } from '@app/core/auth/authentication/hooks/useAuth';
import { useQuery } from '@tanstack/react-query';

/** Query key for audit client config. Use for cache invalidation (e.g. after configUpdate). */
export const auditClientConfigQueryKey = ['client-audit-config'] as const;

/**
 * React Query hook for the audit client config (GET /v2/audit/config).
 * Single source of truth so all consumers share the same cache.
 */
export function useAuditClientConfigQuery() {
  const { client } = useAuth();
  return useQuery({
    queryKey: [...auditClientConfigQueryKey, client?.id],
    queryFn: () => apiClient.audit.configGet(),
  });
}
